import { Flame, CheckCircle2, XCircle } from "lucide-react";
import { useLang } from "@/lib/lang-context";

export const StatusTag = ({ status, size = "md" }) => {
  const { t } = useLang();
  const label = t(`status.${status}`) || status;
  const map = {
    BARGAIN: {
      cls: "bg-[#4A5D23] text-white border-[#3B4A1C]",
      Icon: Flame,
    },
    FAIR: {
      cls: "bg-[#F0EFEB] text-[#282C2A] border-[#E6E4DD]",
      Icon: CheckCircle2,
    },
    OVERPRICED: {
      cls: "bg-[#FBEBE5] text-[#A0522D] border-[#F5C6B5]",
      Icon: XCircle,
    },
  };
  const conf = map[status] || map.FAIR;
  const Icon = conf.Icon;
  const padding = size === "lg" ? "px-4 py-2 text-sm" : "px-3 py-1 text-xs";
  return (
    <span
      data-testid={`status-tag-${status}`}
      className={`inline-flex items-center gap-2 font-bold tracking-[0.18em] uppercase border ${conf.cls} ${padding}`}
    >
      <Icon size={size === "lg" ? 16 : 13} strokeWidth={2} />
      {label}
    </span>
  );
};

export default StatusTag;
